import { isBefore } from 'date-fns'

import { EMPTY_STRING } from '../../constants/common'
import { DATE_HOURS_FORMAT, DATE_SHORT_FORMAT } from '../../constants/date'
import {
  RENTAL_PORTAL_FACT_SEPARATOR,
  RENTAL_PORTAL_VIEWING_STATUS_SLOT_OPEN,
} from '../../constants/rentalPortal'
import { PROFILE_ROUTE_NAMES } from '../../constants/route'
import { toUkTimezoneDate } from '../../utils/date'
import { getListingUnitLabel } from '../RentalPortalListing'
import { formatDate } from '../Table'

import {
  IS_VIEWING_BOOKING_AVAILABLE,
  VIEWING_COLUMN_CONFIG,
} from './RentalPortalViewing.constants'

function getListingViewingTimeLabel({ locale, timezone, value }) {
  return value
    ? formatDate({
        date: value,
        dateFormat: DATE_HOURS_FORMAT,
        locale,
        timezone,
        useTodayFormat: false,
      })
    : EMPTY_STRING
}

export function getViewingTimeLabel({ locale, timezone, value }) {
  return value
    ? formatDate({
        date: value,
        dateFormat: DATE_HOURS_FORMAT,
        locale,
        timezone,
        useTodayFormat: false,
      })
    : EMPTY_STRING
}

export function getViewingTimeRangeLabel({ end, locale, start, timezone }) {
  const startLabel = getViewingTimeLabel({ locale, timezone, value: start })

  const endLabel = getViewingTimeLabel({ locale, timezone, value: end })

  return startLabel && endLabel ? `${startLabel} – ${endLabel}` : startLabel
}

export function getViewingObjectName({ locale, t, timezone, viewing }) {
  const dateLabel = formatDate({
    date: viewing.start,
    dateFormat: DATE_SHORT_FORMAT,
    locale,
    timezone,
    useTodayFormat: false,
  })

  return `${getListingUnitLabel({ listing: viewing, t })}${RENTAL_PORTAL_FACT_SEPARATOR}${dateLabel}`
}

export function toViewingManagerCellValue(viewing) {
  return viewing?.manager_label
    ? {
        user: {
          avatarColor: viewing.manager_avatar_color,
          fullname: viewing.manager_label,
          key: viewing.manager_label,
        },
      }
    : null
}

export function toViewingApplicantIdentity(applicant) {
  const isMasked = applicant.masked !== false

  return {
    avatar_color: applicant.avatar_color,
    identity: { masked: isMasked, value: isMasked ? null : applicant.label },
    reference: applicant.reference,
  }
}

export function getIsViewingPast({ timezone, viewing }) {
  return isBefore(
    toUkTimezoneDate(viewing.start, timezone),
    toUkTimezoneDate(new Date(), timezone)
  )
}

export function getIsViewingSlotBookable({ timezone, viewing }) {
  return (
    IS_VIEWING_BOOKING_AVAILABLE &&
    getIsViewingOpenSlot(viewing) &&
    !getIsViewingPast({ timezone, viewing })
  )
}

export function getIsViewingApplicantPreviewable(viewing) {
  return Boolean(viewing.applicant?.can_view)
}

export function getViewingsColumns() {
  return Object.fromEntries(
    Object.entries(VIEWING_COLUMN_CONFIG).map(([name, config]) => [
      name,
      {
        ...config,
        name,
        ordering_field: name,
        visible: config.visible ?? true,
      },
    ])
  )
}

export function getListingViewingTimeRangeLabel({
  end,
  locale,
  start,
  timezone,
}) {
  const startLabel = getListingViewingTimeLabel({
    locale,
    timezone,
    value: start,
  })

  const endLabel = getListingViewingTimeLabel({ locale, timezone, value: end })

  return startLabel && endLabel ? `${startLabel} – ${endLabel}` : startLabel
}

export function getViewingProfileLink(viewingId) {
  return PROFILE_ROUTE_NAMES.rentalPortalViewingProfile({ id: viewingId })
}

export function getIsViewingOpenSlot(viewing) {
  return viewing.status === RENTAL_PORTAL_VIEWING_STATUS_SLOT_OPEN
}
